var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],class:_vm.b('content')},[_vm._t("default")],2),_c('div',{class:_vm.b('trigger'),on:{"click":_vm.onClickTrigger}},[_vm._t("trigger",function(){return [_vm._v("Ver más")]},{"open":_vm.open})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }